<template>
  <section class="main-service">
    <div class="main-title">
      <html-view :value="$t('main.service.title1')" tag="h3" />
      <html-view :value="$t('main.service.subtitle1')" tag="small" />
    </div>
    <div class="main-content">
      <div class="service-desc">
        <!--          <img src="@/static/image/main/pc/season_1_bg.jpg" alt="">-->
        <div class="player-wrap">
          <video
            ref="video"
            muted
            loop
            playsinline
          >
            <source src="@/static/video/main_service.mp4" type="video/mp4">
            Sorry, your browser doesn't support embedded videos.
          </video>
          <div class="player-control">
            <button
              v-if="!isPlay"
              type="button"
              class="btn-stop"
              @click="isPlay = true"
            >
              <icon-stop />
            </button>
            <button
              v-else
              type="button"
              class="btn-play"
              @click="isPlay = false"
            >
              <icon-play />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-title">
      <html-view :value="$t('main.service.title2')" tag="h3" />
      <html-view :value="$t('main.service.subtitle2')" tag="small" />
    </div>
  </section>
</template>

<script>
export default {
  components: {
    iconPlay: () => import('@/static/svg/play.svg'),
    iconStop: () => import('@/static/svg/stop.svg')
  },
  data () {
    return {
      io: null,
      isPlay: false
    }
  },
  watch: {
    isPlay (play) {
      if (play) {
        this.$refs.video.currentTime = 0
        const playPromise = this.$refs.video.play()

        if (playPromise !== undefined) {
          playPromise.then(video => {
            video.play()
          }).catch(e => {})
        }
      } else {
        this.$refs.video.pause()
      }
    }
  },
  mounted () {
    this.onObserver()
  },
  beforeDestroy () {
    this.io.disconnect()
  },
  methods: {
    onObserver () {
      if (!('IntersectionObserver' in window) ||
          !('IntersectionObserverEntry' in window) ||
          !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
        return false
      }

      this.io = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting }) => {
          this.isPlay = !!isIntersecting
        })
      }, {
        threshold: [0],
        rootMargin: '0px 0px 0px 0px'
      })

      this.io.observe(this.$el)
    }
  }
}
</script>
